import { ButtonStyle } from '@wix/podcasts-common/dist/settings';
import { LINK_HOVER_OPACITY } from './dynamicStyleConstants';

function isFullButtonStyle(buttonStyle) {
  return (
    buttonStyle === ButtonStyle.ROUND_FULL ||
    buttonStyle === ButtonStyle.SQUARE_FULL
  );
}

function getButtonStyles({
  buttonStyle,
  buttonColor,
  buttonTextColor,
  emptyButtonHoverTextColor,
}) {
  if (isFullButtonStyle(buttonStyle)) {
    return {
      backgroundColor: buttonColor,
      border: 'none',
      color: buttonTextColor,
      '&:hover': {
        opacity: LINK_HOVER_OPACITY,
      },
    };
  }

  return {
    backgroundColor: 'none',
    borderColor: buttonColor,
    color: buttonColor,
    '&:hover': {
      backgroundColor: buttonColor,
      color: emptyButtonHoverTextColor,
    },
  };
}

export default getButtonStyles;
